export enum RoutePaths {
  Home = '/',

  Polls = '/polls',
  PollsActive = '/polls/active',
  PollsFinished = '/polls/finished',
  PollsDrafts = '/polls/drafts',

  NewPoll = '/polls/new',
  Poll = '/polls/:id',

  Whitepaper = '/whitepaper',
}
